export enum MutationOperation {
    Add,
    Remove,
    Reuse,
}

export const GlobalIgnoredMutationAttributes = ['state', 'expanded'];
